import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { WhatsApp } from "@mui/icons-material";
import { selectIsPremium } from "../features/account/accountSlice";
import { ROUTE_PATHS } from "../library/helper";
import { useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import GeneralInfoBox from "./GeneralInfoBox";
import PricingPlanComparisonPopup from "./PricingPlanComparisonPopUp";

const lockedRoutes = [
    ROUTE_PATHS.reduction,
    ROUTE_PATHS.scenario,
    ROUTE_PATHS.removal,
    ROUTE_PATHS.analyticsLocation,
    ROUTE_PATHS.analyticsCarbonIntensity,
];

function LockedContentImpl({
    t,
    children,
    title = "locked.content.title.1",
    body = "locked.content.body.1",
}) {
    const isPremium = useSelector(selectIsPremium);
    const [locked, setLocked] = useState(false);
    const location = useLocation();

    const isLockedRoute = useMemo(() => {
        const p = location.pathname || "/";
        return lockedRoutes.some(prefix => p === prefix || p.startsWith(prefix));
    }, [location.pathname]);

    useEffect(() => { setLocked(false); }, [location.pathname]);

    const handleFirstClick = useCallback((e) => {
        if (isPremium || locked || !isLockedRoute) return;
        e.preventDefault();
        e.stopPropagation();
        setLocked(true);
    }, [isPremium, locked, isLockedRoute]);

    const handleClose = useCallback(() => setLocked(false), []);

    if (isPremium || !isLockedRoute) return children;

    return (
        <div
            // 🔴 Capture on the whole guarded section
            onClickCapture={!locked ? handleFirstClick : undefined}
            // (optional) visual hint after lock
            style={{
                transition: "filter 0.2s ease",
            }}
        >
            {/* The guarded content; disable interactions once locked */}
            <div
                style={{
                    pointerEvents: locked ? "none" : "auto",
                    userSelect: locked ? "none" : "auto",
                }}
            >
                {children}
            </div>

            {/* Portal overlay on top of the entire app */}
            {locked && createPortal(
                <>
                    <div
                        style={{
                            position: "fixed",
                            inset: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.4)",
                            zIndex: 2000,
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                    <div
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 2001,
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <PricingPlanComparisonPopup onClose={handleClose} />
                    </div>
                </>,
                document.body
            )}
        </div>
    );
}

export default withTranslation()(LockedContentImpl);
